import * as React from 'react';

import { localization } from '../../localization/localization';

export interface IConfirmLogoDeleteDialogProps {
    logoId: string;
    onDelete: (logoId: string) => void;
    onKeep: () => void;
}

export default class ConfirmLogoDeleteDialog extends React.PureComponent<IConfirmLogoDeleteDialogProps> {
    constructor(props: IConfirmLogoDeleteDialogProps) {
        super(props);
    }

    public render() {
        return (
            <div className="small-popup-dialog-root">
                <div className="title primary-style" >
                    <h3>{localization.galleryLoc.deleteLogoDialog.title}</h3>
                </div>
                <div className="content-container">
                    <p>{localization.galleryLoc.deleteLogoDialog.content}</p>
                    <div className="buttons-row">
                        <button
                            className="dialog-button primary-style"
                            onClick={() => this.props.onKeep()}>
                            {localization.galleryLoc.deleteLogoDialog.keepBtn}
                        </button>
                        <button
                            className="dialog-button primary-style"
                            onClick={() => this.props.onDelete(this.props.logoId)}>
                            {localization.galleryLoc.deleteLogoDialog.deleteBtn}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/components/gallery/confirm-logo-delete.dialog.tsx